// File: src/pages/AdUnitDetail.tsx
import React, { useEffect, useState } from 'react'
import AdvertiserDropdown from '../components/AdvertiserDropdown'
import EditableField from '../components/EditableField'
import PlacementManager from '../components/PlacementManager'
import { parseAdSettings } from '../helpers/parseAdSettings'
import { useParams } from 'react-router-dom'
import { useData } from '../DataProvider'
import { useDataFetch } from '../hooks/useDataFectch'
import { Placement } from '../types/types'

const generatePlacements = (campaignUnit: any, data: any) => {
  if (!campaignUnit?.placements) return [] as any[]

  return Object.keys(campaignUnit?.placements)
    .map((placement) => {
      const league = data?.leagues?.find((l: any) => l.customId === placement)
      const team = data?.teams?.find((t: any) => t.customId === placement)
      const match = data?.matches?.find((t: any) => t.customId == placement)
      let pl = {
        placement,
        ...campaignUnit?.placements?.[placement],
      }
      if (league) pl = { ...pl, ...league, type: 'league', order: 1 }
      if (team) pl = { ...pl, ...team, type: 'team', order: 2 }
      if (match) pl = { ...pl, ...match, type: 'match', order: 3 }
      return pl
    })
    .sort((a, b) => (a.order || 0) - (b.order || 0))
}

const CampaignUnitDetail = () => {
  const { data } = useData()
  const { id } = useParams<{ id: string }>()
  useDataFetch('adsSettingsNew', 'adsSettings')

  const campaignUnits = data?.adsSettings?.campaignUnits || {}
  const campaignUnit = campaignUnits[id || '']
  const originalPlacements = generatePlacements(campaignUnit, data) || []

  const ids = originalPlacements.map((p) => p.placement)
  useDataFetch(`channels/?ids=${ids.join(',')}`, 'channels')

  console.log('campaignUnit', originalPlacements)
  if (!campaignUnit || originalPlacements.length === 0 || (!originalPlacements[0].customId && !['mytribe', 'whatson', 'channel'].includes(originalPlacements[0].placement))) {
    return (
      <div style={styles.page}>
        <h1 style={styles.title}>Campaign Unit Details</h1>
        <div style={styles.section}>
          <label style={styles.label}>Ad Unit</label>
          <div style={styles.inputWrapper}>
            {/* <EditableField value={adUnit?.adUnit || ''} onSave={() => {}} /> */}
            <b>{campaignUnit?.adUnit}</b>
          </div>
        </div>
        <div style={styles.section}>Loading...</div>
      </div>
    )
  }
  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Campaign Unit Details</h1>
      {/* <div style={styles.section}>
        <label style={styles.label}>Advertiser</label>
        <div style={styles.inputWrapper}>
          <AdvertiserDropdown selected={advertiser} onSelect={setAdvertiser} />
        </div>
      </div> */}
      <div style={styles.section}>
        <label style={styles.label}>Ad Unit</label>
        <div style={styles.inputWrapper}>
          {/* <EditableField value={adUnit?.adUnit || ''} onSave={() => {}} /> */}
          <b>{campaignUnit?.adUnit}</b>
        </div>
      </div>
      <div style={styles.section}>
        <label style={styles.label}>Placements</label>
        <PlacementManager campaignUnit={campaignUnit} originalPlacements={originalPlacements} />
      </div>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    width: '100%',
    margin: '0 auto',
    padding: '2rem',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '1.5rem',
  },
  section: {
    marginBottom: '1.5rem',
  },
  label: {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#4b5563',
    marginBottom: '0.5rem',
  },
  inputWrapper: {
    width: '100%',
    maxWidth: '400px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '2rem',
  },
  saveButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
}

export default CampaignUnitDetail
